module.exports = __webpack_public_path__ + "public/Icons/site_settings.svg?9051c007";